import { ajaxCall } from "@/shared/connection/ajax-call";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";

const WALL_ENDPOINT = `/walls`;

export const wallsService = {
    requestForReview2({ uuid, emails, content, subject }) {
        return ajaxCall
            .post(`${WALL_ENDPOINT}/${uuid}/request2`, { emails, content, subject })
            .catch(handleErrorByMessage());
    },
    publish({ uuid, publish }) {
        return ajaxCall
            .patch(`${WALL_ENDPOINT}/${uuid}/publish`, { publish })
            .catch(handleErrorByMessage());
    },
};

export const WALL_LAYOUTS = {
    board: "board",
    bigslider: "bigslider",
    slider: "slider",
    multislider: "multislider",
    avatars: "avatars",
};
